import React from "react";

import { Row, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { PALETTE } from "../../common/ThemeConstants";


export default function HomeGetStarted() {
  const navigate = useNavigate();
  return (
    <Container>
      <Container className="align-self-center text-center ms-auto me-auto">
        <h1 className="text-center">
          <span style={{ fontWeight: "bold" }}>Inizia ora</span> ad allenarti con FedericoBartoliPT
        </h1>
        <p className="home-subtitle">
          Non perdere altro tempo, inizia subito il tuo percorso di allenamento personalizzato con FedericoBartoliPT.
        </p>
      </Container>
      <br />
      <Row className="m-auto" style={{ maxWidth: "600px" }}>
        <Col
          xs={6}
          className="text-center m-auto d-flex align-items-center justify-content-center"
          style={{
            borderRight: "1px solid " + PALETTE.KINDAGRAY,
            height: 100
          }}
        >
          <div
            className="text-center rounded-sm shadow-sm p-3 m-auto align-self-center bg-secondary-custom"
            style={{
              width: 200,
              fontWeight: "bold",
              cursor: "pointer"
            }}
            onClick={() => navigate("/login")}
          >
            <p className="mb-0">
              Accedi
            </p>
          </div>
        </Col>
        <Col xs={6} className="text-center m-auto d-flex align-items-center justify-content-center">
          <div
            className="text-center rounded-sm shadow-sm p-3 m-auto bg-secondary-custom-outline"
            style={{
              width: 200,
              fontWeight: "bold",
              cursor: "pointer"
            }}
            onClick={() => navigate("/register")}
          >
            <p className="mb-0">
              Registrati ora
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
